"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomFlagIconFactory = exports.default = void 0;

var _FlagIcon = _interopRequireDefault(require("./FlagIcon"));

var _styles = _interopRequireDefault(require("../styles"));

var _functions = require("../functions");

var _props = require("../functions/props");

var _styles2 = require("../functions/styles");

var _propTypes = require("../types/propTypes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var FlagIconFactory = function FlagIconFactory(React, options) {
  var computedOptions = (0, _functions.makeFlagIconOptions)(options);
  var useCssModules = computedOptions.useCssModules,
      customCodes = computedOptions.customCodes;
  var FlagIconComponent = null;

  if (useCssModules) {
    var computedStyles = (0, _functions.makeStyles)(_styles.default, options);

    if (process.env.NODE_ENV !== 'production') {
      (0, _styles2.validateStyles)(computedStyles, computedOptions, options);
    }

    FlagIconComponent = (0, _FlagIcon.default)(React, computedOptions, computedStyles);
  } else {
    FlagIconComponent = (0, _FlagIcon.default)(React, computedOptions);
  }

  FlagIconComponent.displayName = 'FlagIcon';

  if (process.env.NODE_ENV !== 'production') {
    var codes = (0, _props.getCountryCodes)();

    if (customCodes) {
      codes = [].concat(_toConsumableArray(codes), _toConsumableArray(Object.keys(customCodes)));
    }

    FlagIconComponent.propTypes = (0, _propTypes.MakeFlagIconPropsType)(codes);
  }

  return FlagIconComponent;
};

var _default = FlagIconFactory;
exports.default = _default;

var CustomFlagIconFactory = function CustomFlagIconFactory(React, options) {
  return FlagIconFactory(React, options);
};

exports.CustomFlagIconFactory = CustomFlagIconFactory;


//////////////////
// WEBPACK FOOTER
// ./~/react-flag-icon-css/lib/FlagIcon/FlagIconFactory.js
// module id = 337
// module chunks = 168707334958949